'use client';

import { Box, PopperProps } from '@mui/material';
import React, { FC } from 'react';

import { LocationSuggestionOption } from '../../location-search.types';
import { LocationDetailsLabels } from '../location-details/location-details.types';
import { LocationDetails } from '../location-details/LocationDetails';

import { LocationMobilePopper } from './LocationSearchMobilePopper.styling';

export const LocationSearchMobilePopper: FC<
  PopperProps &
    LocationDetailsLabels & {
      showLocationDetailsFeature?: boolean;
      locationDetailOption?: LocationSuggestionOption | null;
    }
> = ({
  showLocationDetailsFeature = false,
  locationDetailOption,
  uiTextData,
  ...props
}) => {
  const isShowLocationDetail =
    showLocationDetailsFeature && !!locationDetailOption;

  return (
    <LocationMobilePopper
      {...props}
      disableRightBorderRadius={isShowLocationDetail}
    >
      <>
        {props.children}

        {isShowLocationDetail && (
          <Box
            sx={{
              overflow: 'hidden',
              marginTop: 1,
              width: '100%',
            }}
            onMouseDown={(event) => event.preventDefault()}
          >
            <LocationDetails
              option={locationDetailOption}
              uiTextData={uiTextData}
            />
          </Box>
        )}
      </>
    </LocationMobilePopper>
  );
};
